import { AaSigninReq } from 'app/bff/models/aa/aaSignin';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ROUTES } from 'app/core/router/paths';
import { ProcessStepCodesEnum } from 'app/features/Member/Settings/Mobile/types';
import { FormValues as SetupFormValues } from 'app/features/Member/Settings/Mobile/Setup/types';
import { MobileState, MobileActions, MEMBER_SETTING_MOBILE__SET_ACCESSIBLE_STEP, MEMBER_SETTING_MOBILE__AUTH_PASS_PHRASE, MEMBER_SETTING_MOBILE__SAVE_SETUP_PAGE_DATA, MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP, MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP_DONE, MEMBER_SETTING_MOBILE__AUTH_MOBILE_OTP, MEMBER_SETTING_MOBILE__SETUP_MOBILE, MEMBER_SETTING_MOBILE__UPDATE_CACHE, MEMBER_SETTING_MOBILE__RESET_CACHE } from './types';

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): MobileActions => ({
  type: MEMBER_SETTING_MOBILE__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 驗證會員密碼 (Action)
 * @param args 請求所需的參數
 */
export const authPassPhraseAction = (args: AaSigninReq): MobileActions => ({
  type: MEMBER_SETTING_MOBILE__AUTH_PASS_PHRASE,
  payload: { args }
});

/**
 * @description 緩存「輸入新手機號碼」(Step-2-1) 資料 (Action)
 * @param data 頁面資料
 */
export const saveSetupPageDataAction = (data: SetupFormValues): MobileActions => ({
  type: MEMBER_SETTING_MOBILE__SAVE_SETUP_PAGE_DATA,
  payload: { data }
});

/**
 * @description 發送手機 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 * @param redirectRoute 轉導路由
 */
export const sendMobileOTPAction = (args: AaOtpSendcodeReq, redirectRoute?: ROUTES): MobileActions => ({
  type: MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP,
  payload: { args, redirectRoute }
});

/**
 * @description 發送手機 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendMobileOTPDoneAction = (response: AaOtpSendcodeResp): MobileActions => ({
  type: MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證手機 OTP 驗證碼 (Action)
 * @param authMobileOTPArgs 驗證手機 OTP 驗證碼，請求所需的參數
 * @param setupMobileArgs 更新會員電子郵件 (更新會員資料)，請求所需的參數
 */
export const authMobileOTPAction = (authMobileOTPArgs: AaOtpVerifyReq, setupMobileArgs: MbUpdateinfoReq): MobileActions => ({
  type: MEMBER_SETTING_MOBILE__AUTH_MOBILE_OTP,
  payload: { authMobileOTPArgs, setupMobileArgs }
});

/**
 * @description 設置會員手機 (Action)
 * @param args 請求所需的參數
 */
export const setupMobileAction = (args: MbUpdateinfoReq): MobileActions => ({
  type: MEMBER_SETTING_MOBILE__SETUP_MOBILE,
  payload: { args }
});

/**
 * @description 更新資料緩存 (Action)
 * @param cache 緩存資料
 */
export const updateCacheAction = (cache: MobileState): MobileActions => ({
  type: MEMBER_SETTING_MOBILE__UPDATE_CACHE,
  payload: { cache }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): MobileActions => ({
  type: MEMBER_SETTING_MOBILE__RESET_CACHE
});
